import { ImageAttributes } from 'types/general.types';

export const imageAttributesDefault: ImageAttributes = {
  height: 1,
  width: 1,
  naturalHeight: 1,
  naturalWidth: 1,
};
